import React from 'react';
import { Box, Grid, Paper, TextField, Typography } from '@mui/material';
import type { MatchStatisticsResponse } from 'src/components/types/types';
import Tooltip  from '@mui/material/Tooltip';
import '../Styles/muiglobal.css';
interface MatchStatisticsProps {
  MatchStatisticsData: MatchStatisticsResponse[];
}

const MatchStatistics: React.FC<MatchStatisticsProps> = ({ MatchStatisticsData }) => {
  // const userRoleDet = localStorage.getItem('role');
  // useEffect(() => {
  //        if(userRoleDet != null){
          
  //         // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  //         const userRoles = JSON.parse(userRoleDet);
  //         // eslint-disable-next-line
  //         const roleID = userRoles[0]?.roleID; 
  //         setLoginUserRole(roleID);
  //        }
  //     }, [userRoleDet]);
      const formatDate = (dateString: string | number | Date):string =>  {
        const date = new Date(dateString);
      
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
      
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
      
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        hours = hours % 12 || 12; // Convert to 12-hour format
        const formattedTime = `${hours}:${minutes}${ampm}`;
      
        return `${month}/${day}/${year} ${formattedTime}`;
      }
  // Combined Job Statistics with labels and values
  const jobStatistics = [
    { label: 'Job ID', value: MatchStatisticsData[0].jobId },
    { label: 'Job Started', value: formatDate(MatchStatisticsData[0].jobStartDate)},
    { label: 'Job Ended', value: formatDate(MatchStatisticsData[0].jobEndDate) },
    { label: 'Client ID', value: MatchStatisticsData[0].clientId },
    { label: 'Source Server', value: MatchStatisticsData[0].sourceServerName },
    { label: 'Source Database', value: MatchStatisticsData[0].sourceDatabaseName },
    { label: 'Source Table Name', value: MatchStatisticsData[0].sourceTableName },
  ];
  
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const uniqueEmailCount = parseInt(MatchStatisticsData[0].uniqueEmail) || 0;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const emailSuppressedCount = parseInt(MatchStatisticsData[0].emailSuppressed) || 0;
  const matchStatistics = [
    { label: 'Total Records', value: MatchStatisticsData[0].totalRecords },
    { label: 'Total Provider Matched', value: MatchStatisticsData[0].totalRecordsMatched },
    { label: 'Unique Providers Matched', value: MatchStatisticsData[0].uniqueProviderMatched },
    { label: 'Unique Tier 1 Emails Matched (Unique Tier 1 Emails Available + Unique Tier 1 Emails Suppressed)', 
      value: uniqueEmailCount + emailSuppressedCount },
  ];

  const detailedStatistics = MatchStatisticsData[0].matchAppendTitleBreakdown.map((item) => ({
    label: item.description,
    uniqueProvidersMatched: item.uniqueProvidersMatched,
    uniqueTier1EmailsAvail: item.uniqueTier1EmailsAvail,
    uniqueTier1EmailsSuppressed: item.uniqueTier1EmailsSuppressed,
    totalUniqueTier1Emails: item.totalUniqueTier1Emails,
    tier1EmailsAvailRate: item.tier1EmailsAvailRate,
    tier1EmailsSuppRate: item.tier1EmailsSuppRate,
    tier1EmailMatchRate: item.tier1EmailMatchRate,
    hlTier1EmailFillRate: item.hlTier1EmailFillRate
  }));
  const detailedSpecialtyBreakdown = MatchStatisticsData[0].matchAppendSpecialityBreakdown.map((item) => ({
    label: item.description,
    uniqueProvidersMatched: item.uniqueProvidersMatched,
    uniqueTier1EmailsAvail: item.uniqueTier1EmailsAvail,
    uniqueTier1EmailsSuppressed: item.uniqueTier1EmailsSuppressed,
    totalUniqueTier1Emails: item.totalUniqueTier1Emails,
    tier1EmailsAvailRate: item.tier1EmailsAvailRate,
    tier1EmailsSuppRate: item.tier1EmailsSuppRate,
    tier1EmailMatchRate: item.tier1EmailMatchRate,
    hlTier1EmailFillRate: item.hlTier1EmailFillRate
  }));
  const AppendStatistics = [
    { label: 'Total Tier 1 Emails Available', value: MatchStatisticsData[0].uniqueEmail },
    { label: 'Unique Tier 1 Emails Available', value: MatchStatisticsData[0].uniqueEmail },
    { label: 'Unique Tier 1 Emails Suppressed', value: MatchStatisticsData[0].emailSuppressed },
    { label: 'Unique Tier 1 Email Suppressed on Project Basis', value: MatchStatisticsData[0].emailSuppressionLvl1 },
    { label: 'Unique Tier 1 Email Suppressed per Client Email Exclusion', value: MatchStatisticsData[0].emailSuppressionLvl2 },
    { label: 'Unique Tier 1 Email Suppressed per Client Domain Exclusions', value: MatchStatisticsData[0].emailSuppressionLvl3 },
    { label: 'Address Available', value: MatchStatisticsData[0].address},
    { label: 'Mailable Address Available', value: MatchStatisticsData[0].mailable },
    { label: 'Phone Available', value: MatchStatisticsData[0].phone },
    { label: 'Group Affiliation Available', value: MatchStatisticsData[0].groupAffiliation },
    { label: 'Hospital Affiliation Available', value: MatchStatisticsData[0].hospitalAffiliation },
    { label: 'NPI Available', value: MatchStatisticsData[0].npi },
    { label: 'Title Available', value: MatchStatisticsData[0].title },
    { label: 'Specialty Available', value: MatchStatisticsData[0].specialty },
    { label: 'Taxonomy Available', value: MatchStatisticsData[0].taxonomy },
    { label: 'State License Number Available', value: MatchStatisticsData[0].stateLicenseNumber },
    { label: 'DEA Number Available', value: MatchStatisticsData[0].deaNumber }
  ];
  return (
    <>
      <Box className="px-[16px] pt-[10px] mb-[8px]">
        <TextField
          id="outlined-basic"
          label="Job ID"
          variant="outlined"
          fullWidth
          name="Description"
          value={MatchStatisticsData[0].jobId}
          autoComplete="off"
          InputProps={{
            style: {
              textAlign: 'center',
              color: '#000000',
              fontSize: '18px',
              fontWeight: '700',
              WebkitTextFillColor: '#000000',
            },
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#f9f9f9', // Gray background color
              '& fieldset': {
                borderColor: '#d0d0d0',
              },
              '&:hover fieldset': {
                borderColor: '#b0b0b0',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#D6242C',
              },
            },
            '& input': {
              textAlign: 'center',
              padding: '7px', // Adjust padding to fit within the TextField
              color: '#000000 !important',
              fontSize: '18px !important',
              fontWeight: '700 !important',
              '-webkit-text-fill-color': '#000000 !important',
              opacity: '1 !important',
              backgroundColor: '#f5f5f5 !important', // Ensure background color is applied
            },
            '& label': {
              textAlign: 'left',
              color: '#343434',
              top: '-6px', // Adjust label position to account for increased padding
            },
            '& label.Mui-focused': {
              color: '#D6242C',
            },
          }}
          InputLabelProps={{
            shrink: true,
          }}
          disabled
        />
      </Box>

      {/* Job Statistics Section */}
      <div className="bg-white rounded-md p-6">
        {jobStatistics.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Job Statistics
            </Typography>
            <Paper sx={{ mb: 4, boxShadow: 'none' }}>
              <Grid container spacing={0}>
                {jobStatistics.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        backgroundColor: '#fff',
                        color: '#343434',
                      }}
                    >
                      {item.label}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                        color: '#343434',
                      }}
                    >
                      {item.value}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          </>
        )}

        {/* Match Statistics Section */}
        {matchStatistics.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Match Statistics
            </Typography>
            <Paper sx={{ mb: 4, boxShadow: 'none' }}>
              <Grid container spacing={0}>
                {matchStatistics.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA', // Gray horizontal line
                        p: 1,
                        backgroundColor: '#fff',
                        color: '#343434',
                      }}
                    >
                      {item.label}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA', // Gray horizontal line
                        p: 1,
                        textAlign: 'left',
                        color: '#343434', // Consistent value color
                      }}
                    >
                      {item.value}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          </>
        )}

        {/* Append Statistics Section */}
        {AppendStatistics.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Append Statistics
            </Typography>
            <Paper sx={{ mb: 4, boxShadow: 'none' }}>
              <Grid container spacing={0}>
                <Grid
                  xs={6}
                  sx={{
                    border: 'none',
                    borderBottom: '1px solid #DADADA', // Gray horizontal line
                    p: 1,
                    backgroundColor: '#f5f5f5',
                    color: '#343434',
                    textAlign: 'left',
                    fontWeight: 'bold',
                  }}
                  item
                >
                  Data Field
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    border: 'none',
                    borderBottom: '1px solid #DADADA', // Gray horizontal line
                    p: 1,
                    textAlign: 'left',
                    fontWeight: 'bold',
                    color: '#343434',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  Unique Provider
                </Grid>

                {AppendStatistics.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA', // Gray horizontal line
                        p: 1,
                        backgroundColor: '#fff',
                        color: '#343434',
                      }}
                    >
                      {item.label}
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        border: 'none',
                        borderBottom: '1px solid #DADADA', // Gray horizontal line
                        p: 1,
                        textAlign: 'left',
                        color: '#343434', // Consistent value color
                      }}
                    >
                      {item.value}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          </>
        )}
        {/*  Email Source Breakdown INTERNAL USE ONLY - DO NOT SEND TO CLIENTS Section */}
        {MatchStatisticsData[0].matchAppendEmailSourceBreakdown.length > 0 &&
        <>
          <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
            Email Source Breakdown INTERNAL USE ONLY - DO NOT SEND TO CLIENTS
          </Typography>
          <Paper elevation={0} sx={{ mb: 4, boxShadow: 'none' }}>
            <Grid container spacing={0}>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Email Source" arrow>
                  <span className="ellipsisText">Email Source</span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Total Tiers Requested" arrow>
                  <span className="ellipsisText">Total Tiers Requested</span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Tier 1 Available" arrow>
                  <span className="ellipsisText">Tier 1 Available</span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Tier 2 Available" arrow>
                  <span className="ellipsisText">Tier 2 Available</span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Tier 3 Available" arrow>
                  <span className="ellipsisText">Tier 3 Available</span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} className="gridItemHeading">
                <Tooltip title="Tier 4 Available" arrow>
                  <span className="ellipsisText">Tier 4 Available</span>
                </Tooltip>
              </Grid>

              {MatchStatisticsData[0].matchAppendEmailSourceBreakdown.map(
                (item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.emailSource}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.totalTiersRequested}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1Avail}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier2Avail}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier3Avail}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier4Avail}
                    </Grid>
                  </React.Fragment>
                ),
              )}
            </Grid>
          </Paper>
        </>
}
        {/* Provider Status Section */}
        {MatchStatisticsData[0].matchAppendProviderStatus.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Provider Status
            </Typography>
            <Paper elevation={0} sx={{ boxShadow: 'none', mb: 4 }}>
              <Grid container spacing={0}>
                <Grid
                  item
                  xs={8}
                  sx={{
                    p: 1,
                    fontWeight: 'bold',
                    textAlign: 'left',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  Provider Status
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    p: 1,
                    fontWeight: 'bold',
                    textAlign: 'left',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  Unique Provider
                </Grid>

                {MatchStatisticsData[0].matchAppendProviderStatus.map(
                  (item, index) => (
                    <React.Fragment key={index}>
                      <Grid
                        item
                        xs={8}
                        sx={{
                          borderBottom: '1px solid #DADADA',
                          p: 1,
                          textAlign: 'left',
                        }}
                      >
                        {item.status}
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        sx={{
                          borderBottom: '1px solid #DADADA',
                          p: 1,
                          textAlign: 'left',
                        }}
                      >
                        {item.totalNoofProviders}
                      </Grid>
                    </React.Fragment>
                  ),
                )}
              </Grid>
            </Paper>
          </>
        )}

        {/* Detailed Specialty Breakdown */}
        {MatchStatisticsData[0].matchAppendSpecialityBreakdown.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Top 10 Specialty Breakdown
            </Typography>
            <Paper elevation={0} sx={{ boxShadow: 'none', mb: 4 }}>
              <Grid container spacing={0}>
                <Grid item xs={2.25} className="gridItemHeading">
                  <Tooltip title="Specialty" arrow>
                    <span className="ellipsisText">Specialty</span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Unique Providers Matched" arrow>
                    <span className="ellipsisText">
                      Unique Providers Matched
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Unique Tier 1 Emails Available" arrow>
                    <span className="ellipsisText">
                      Unique Tier 1 Emails Available
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Unique Tier 1 Emails Suppressed" arrow>
                    <span className="ellipsisText">
                      Unique Tier 1 Emails Suppressed
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} className="gridItemHeading">
                  <Tooltip title="Total Unique Tier 1 Emails" arrow>
                    <span className="ellipsisText">
                      Total Unique Tier 1 Emails
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} className="gridItemHeading">
                  <Tooltip title="Tier 1 Emails Available Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Emails Available Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.5} className="gridItemHeading">
                  <Tooltip title="Tier 1 Emails Suppressed Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Emails Suppressed Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} className="gridItemHeading">
                  <Tooltip title="Tier 1 Email Match Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Email Match Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.5} className="gridItemHeading">
                  <Tooltip title="Healthlink Tier 1 Email Fill Rate" arrow>
                    <span className="ellipsisText">
                      Healthlink Tier 1 Email Fill Rate
                    </span>
                  </Tooltip>
                </Grid>
                {detailedSpecialtyBreakdown.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={2.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.label}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueProvidersMatched}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueTier1EmailsAvail}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueTier1EmailsSuppressed}
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.totalUniqueTier1Emails}
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailsAvailRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1.5}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailsSuppRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailMatchRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1.5}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.hlTier1EmailFillRate}%
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          </>
        )}
        {/* Standardized Title Breakdown */}
        {MatchStatisticsData[0].matchAppendTitleBreakdown.length > 0 && (
          <>
            <Typography gutterBottom sx={{ fontWeight: 'bold' }}>
              Top 10 Standardized Title Breakdown
            </Typography>
            <Paper elevation={0} sx={{ boxShadow: 'none', mb: 4 }}>
              <Grid container spacing={0}>
                <Grid item xs={1.5} className="gridItemHeading">
                  <Tooltip title="Description" arrow>
                    <span className="ellipsisText">Description</span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Unique Providers Matched" arrow>
                    <span className="ellipsisText">
                      Unique Providers Matched
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Unique Tier 1 Emails Available" arrow>
                    <span className="ellipsisText">
                      Unique Tier 1 Emails Available
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.75} className="gridItemHeading">
                  <Tooltip title="Unique Tier 1 Emails Suppressed" arrow>
                    <span className="ellipsisText">
                      Unique Tier 1 Emails Suppressed
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title="Total Unique Tier 1 Emails" arrow>
                    <span className="ellipsisText">
                      Total Unique Tier 1 Emails
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} className="gridItemHeading">
                  <Tooltip title="Tier 1 Emails Available Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Emails Available Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.75} className="gridItemHeading">
                  <Tooltip title="Tier 1 Emails Suppressed Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Emails Suppressed Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1} className="gridItemHeading">
                  <Tooltip title="Tier 1 Email Match Rate" arrow>
                    <span className="ellipsisText">
                      Tier 1 Email Match Rate
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs={1.25} className="gridItemHeading">
                  <Tooltip title=" Healthlink Tier 1 Email Fill Rate" arrow>
                    <span className="ellipsisText">
                      {' '}
                      Healthlink Tier 1 Email Fill Rate
                    </span>
                  </Tooltip>
                </Grid>
                {detailedStatistics.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid
                      item
                      xs={1.5}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.label}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueProvidersMatched}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueTier1EmailsAvail}
                    </Grid>
                    <Grid
                      item
                      xs={1.75}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.uniqueTier1EmailsSuppressed}
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.totalUniqueTier1Emails}
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailsAvailRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1.75}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailsSuppRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.tier1EmailMatchRate}%
                    </Grid>
                    <Grid
                      item
                      xs={1.25}
                      sx={{
                        borderBottom: '1px solid #DADADA',
                        p: 1,
                        textAlign: 'left',
                      }}
                    >
                      {item.hlTier1EmailFillRate}%
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          </>
        )}
      </div>
    </>
  );
};

export default MatchStatistics;
